import React from 'react';
import { Link } from 'react-router-dom';

export default function PostCard({ post }) {
  if (!post) return null;
  return (
    <article style={{ padding: 12, borderBottom: '1px solid #f0f0f0' }}>
      <h3><Link to={`/post/${post.id}`}>{post.title}</Link></h3>
      <p style={{ color: '#666' }}>{post.content.slice(0, 120)}{post.content.length>120?'…':''}</p>
    </article>
  );
}
